export const CHUNK_SIZE = 10 * 1024 * 1024;
export const GCM_TAG_BYTES = 16;
export const DEFAULT_UPLOAD_CONCURRENCY = 4;
export const MAX_RETRY_ATTEMPTS = 3;
export const PRESIGNED_URL_EXPIRY_SECONDS = 3600;
export const SESSION_TTL_SECONDS = 60 * 60 * 24;
export const MIN_EXPIRY_HOURS = 1;
export const DEFAULT_MAX_EXPIRY_HOURS = 24 * 7;
export const MAX_READS_UPPER_BOUND = 1000;
